// Регистрация панелей табеля в каркасе. Побочный эффект при загрузке модуля: раздел объявляет,
// что умеет рисовать в стопке панелей, а каркас остаётся без знания о нём.

import { registerPanel } from '@/layout/panel-registry';

import { PANEL_TS_UNASSIGNED } from '../route';

import { НеПопалиВТабель } from './НеПопалиВТабель';

registerPanel(PANEL_TS_UNASSIGNED, {
  title: () => 'Не попали в табель',
  render: ({ id }) => <НеПопалиВТабель id={id} />,
});
